var has = require('../internals/map-helpers').has;

// Perform ? RequireInternalSlot(M, [[MapData]])
module.exports = function (it) {
  has(it);
  return it;
};



// WEBPACK FOOTER //
// /Users/stephen.tait/Local Sites/storyiq/app/public/web/wp-content/themes/jaywing/node_modules/core-js/internals/a-map.js